import styled, { css } from 'styled-components';

import { Link } from '@powdr/components';
import {
  Components, Breakpoints, ThemeProps as Prop, FontSize, FontFamily,
} from '@powdr/constants';
import { componentColor, getFontStyles } from '@powdr/utils';

export const StyledFooterContact = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 25px 7.5%;
  background-color: ${() => componentColor(Prop.BACKGROUND, Components.FOOTER_CONTACT, Prop.BACKGROUND)};

  ${Breakpoints.mobile(css`
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 25px 4.5%;
    gap: 15px;
  `)}
`;

const sharedItemStyles = css`
  display: flex;
  gap: 7px;
  align-items: center;
  justify-content: center;
  color: ${() => componentColor(Prop.CONTENT, Components.FOOTER_CONTACT, Prop.CONTENT)};
  ${() => getFontStyles(FontFamily.BASE_FONT, FontSize.REG50, undefined, undefined)};
  padding: 0 25px;
  border-right: 1px solid ${() => componentColor(Prop.CONTENT, Components.FOOTER_CONTACT, Prop.CONTENT)};

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
    border-right: none;
  }

  ${Breakpoints.mobile(css`
    border: none;
    padding: 0 0;
  `)}

  svg {
    fill: ${() => componentColor(Prop.CONTENT, Components.FOOTER_CONTACT, Prop.CONTENT)};
    color: ${() => componentColor(Prop.CONTENT, Components.FOOTER_CONTACT, Prop.CONTENT)};
  }
`;

const linkStyles = css`
  transition: all .25s ease-out;

  &:hover {
    color: ${() => componentColor(Prop.LINK_TXT_HOVER, Components.FOOTER_CONTACT, Prop.LINK_TXT_HOVER)};

    svg {
      fill: ${() => componentColor(Prop.LINK_TXT_HOVER, Components.FOOTER_CONTACT, Prop.LINK_TXT_HOVER)};
      color: ${() => componentColor(Prop.LINK_TXT_HOVER, Components.FOOTER_CONTACT, Prop.LINK_TXT_HOVER)};
    }
  }

  &:focus {
    outline: 2px solid ${() => componentColor(Prop.LINK_TXT_HOVER, Components.FOOTER_CONTACT, Prop.LINK_TXT_HOVER)};
    color: ${() => componentColor(Prop.LINK_TXT_HOVER, Components.FOOTER_CONTACT, Prop.LINK_TXT_HOVER)};

    svg {
      fill: ${() => componentColor(Prop.LINK_TXT_HOVER, Components.FOOTER_CONTACT, Prop.LINK_TXT_HOVER)};
      color: ${() => componentColor(Prop.LINK_TXT_HOVER, Components.FOOTER_CONTACT, Prop.LINK_TXT_HOVER)};
    }
  }
`;

export const AddressWrapper = styled.div`
 ${sharedItemStyles}
`;

export const Address = styled.div``;

export const PhoneNumber = styled(Link)`
  ${sharedItemStyles}
  ${linkStyles}
`;

export const Email = styled(Link)`
  ${sharedItemStyles}
  ${linkStyles}
`;
